import React from 'react';

const Success = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h1>✅ Payment Successful!</h1>
      <p>Thank you for your payment.</p>
    </div>
  );
};

export default Success;
